export function formatPhoneNumber(phone) {
  if (phone === '') {
    return phone;
  }
  const codeMatch = phone?.match(/\+(\d+)/);
  const code = codeMatch ? codeMatch[0] : '';

  const digits = phone?.match(/\d/g).join('');
  const value = code ? digits.slice(code.length - 1) : digits;

  return {
    code: code,
    value: value,
  };
}
